import Vue from '@mindful-web/marko-web/browser/vue';
import VModal from 'vue-js-modal/dist/index.nocss';
import jQuery from '@mindful-web/marko-web/browser/jquery-full';
import NativeX from '@mindful-web/marko-web-native-x/browser';
import Search from '@mindful-web/marko-web-search/browser';
import RevealAd from '@mindful-web/marko-web-reveal-ad/browser';
import Inquiry from '@mindful-web/marko-web-inquiry/browser';
import DefaultTheme from '@mindful-web/marko-web-theme-default/browser';
import GTM from '@mindful-web/marko-web-gtm/browser';
import GAM from '@mindful-web/marko-web-gam/browser';
import GCSE from '@mindful-web/marko-web-gcse/browser';
import SocialSharing from '@mindful-web/marko-web-social-sharing/browser';
import PhotoSwipe from '@mindful-web/marko-web-photoswipe/browser';

Vue.use(VModal);

const CompanyProfileWebsiteLink = () => import(/* webpackChunkName: "company-profile-website-link" */ './website-link.vue');
const CompanyProfileSocialLink = () => import(/* webpackChunkName: "company-profile-social-link" */ './social-link.vue');
const NoticePushdown = () => import(/* webPackChunkName: "jump-modal" */ './notice-pushdown.vue');
const NavigationDropdownAnchors = () => import(/* webPackChunkName: "navigation-dropdown-anchors" */ './navigation-dropdown-anchors.vue');

window.jQuery = jQuery;
window.$ = jQuery;

export default (Browser) => {
  DefaultTheme(Browser);
  GTM(Browser);
  GAM(Browser);
  GCSE(Browser);
  NativeX(Browser);
  RevealAd(Browser);
  SocialSharing(Browser);
  PhotoSwipe(Browser);
  Inquiry(Browser);
  Search(Browser);

  Browser.register('CompanyProfileWebsiteLink', CompanyProfileWebsiteLink);
  Browser.register('CompanyProfileSocialLink', CompanyProfileSocialLink);
  Browser.register('NoticePushdown', NoticePushdown);
  Browser.register('NavigationDropdownAnchors', NavigationDropdownAnchors);
};
